import { css } from '@emotion/react';
import { Button } from 'components/Button';
import { SpinnerBlock } from 'components/SpinnerBlock';

import React, { ReactNode } from 'react';
import { NavLink } from 'react-router-dom';
import { routes } from 'routes';

import { theme } from 'styles/theme';
import { ConnectToGoogle } from '../screens/ExampleScreen';
import authStore from 'modern/authStore';
import { observer } from 'mobx-react-lite';
import { useCurrentUserQuery, useOrganizationQuery } from 'generated/graphql';

export const Layout = observer(({ children }: { children: ReactNode }) => {
	const [{ fetching, data }] = useCurrentUserQuery();
	const [organization] = useOrganizationQuery();

	const NAV_WIDTH = 240;

	return (
		<div
			css={css`
				display: flex;
				height: 100%;
				width: 100%;
			`}
		>
			<div
				css={css`
					width: ${NAV_WIDTH}px;
					background: #fff;
					border-right: 1px solid #f1f1f4;
					flex-shrink: 0;

					position: fixed;
					left: 0;
					top: 0;
					bottom: 0;
				`}
			>
				<div
					css={css`
						display: flex;
						justify-content: center;
						padding: 24px 0;
					`}
				>
					{!organization.fetching && (
						<img
							src={`data:image/svg+xml;base64,${btoa(organization?.data?.organization?.logo)}`}
						/>
					)}
				</div>

				<div
					css={css`
						padding: 0 12px;
					`}
				>
					<NavItem to={routes.booker.request}>Poptávky</NavItem>
					{/* <NavItem to="/booker/calendar">Kalendář</NavItem> */}
					<NavItem to="/booker/artists/">Interpreti</NavItem>
					<NavItem to="/booker/settings/">Nastavení</NavItem>
				</div>

				<div>
					<ConnectToGoogle />
				</div>

				<div>
					{fetching ? (
						<SpinnerBlock />
					) : (
						<div
							css={css`
								font-size: 13px;
								padding: 0 24px;
								margin-top: 24px;
							`}
						>
							<div>
								<strong>{data.currentUser && data.currentUser?.name}</strong>
							</div>
							<div
								css={css`
									margin-bottom: 12px;
								`}
							>
								{data.currentUser && data.currentUser?.email}
							</div>
							<NavLink
								to={routes.booker.account}
								css={css`
									margin-bottom: 20px;
									display: inline-block;
								`}
							>
								Nastavení účtu
							</NavLink>

							<Button
								outline
								small
								onClick={() => {
									authStore.logout();
								}}
							>
								Odhlásit se
							</Button>
						</div>
					)}
				</div>
			</div>
			<div
				css={css`
					flex-grow: 1;
					margin-left: ${NAV_WIDTH}px;
				`}
			>
				{children}
			</div>
		</div>
	);
});

const NavItem = ({ to, children }: { to: string; children: ReactNode }) => {
	return (
		<NavLink
			to={to}
			css={css`
				display: flex;
				padding: 12px;
				color: ${theme.color.text['400']};
				border-radius: 12px;
				margin: 2px 0;

				&:hover {
					background: ${theme.color.primary['50']};
					text-decoration: none;
					color: ${theme.color.primary['400']};
				}

				&.active {
					color: ${theme.color.primary['400']};
					font-weight: bold;
					background: ${theme.color.primary['50']};
				}
			`}
		>
			{children}
		</NavLink>
	);
};
